<template>
  <div :class="bem()">
    <slot name="header"></slot>
    <v-menu
        ref="menuDateFrom"
        v-model="dateFromMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
      >
        <v-text-field slot="activator"
          :value="refinementForRendering.min"
          label="Date from"
          prepend-icon="event"
          readonly
          @change="onInputMin($event)"
        ></v-text-field>
      <v-date-picker :value="refinementForRendering.min" @input="dateFromMenu = false;onInputMin($event)"></v-date-picker>
    </v-menu>
    <slot name="separator">
      <span :class="bem('separator')">
        to
      </span>
    </slot>
    <v-menu
        ref="menuDateTo"
        v-model="dateToMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
      >
        <v-text-field slot="activator"
          :value="refinementForRendering.max"
          label="Date To"
          prepend-icon="event"
          readonly
          @change="onInputMax($event)"
        ></v-text-field>
      <v-date-picker :value="refinementForRendering.max" @input="dateToMenu = false;onInputMax($event)"></v-date-picker>
    </v-menu>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import parse from 'date-fns/parse'
import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import { RangeInput, FACET_OR } from 'vue-instantsearch'

export default {
  name: 'ais-dates-range-input',
  extends: RangeInput,
  props: {
    attributeName: {
      type: String,
      required: true
    },
    min: {
      type: String
    },
    max: {
      type: String
    },
    defaultRefinement: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      blockClassName: 'ais-dates-range-input',
      dateFromMenu: false,
      dateToMenu: false
    }
  },
  created () {
    const { min: minValue, max: maxValue } = this.defaultRefinement

    let min
    if (minValue !== undefined) {
      min = minValue
    } else if (this.min !== undefined) {
      min = this.min
    }

    let max
    if (maxValue !== undefined) {
      max = maxValue
    } else if (this.max !== undefined) {
      max = this.max
    }

    this.searchStore.stop()

    this.searchStore.addFacet(this.attributeName, FACET_OR)

    if (min !== undefined) {
      this.searchStore.addNumericRefinement(this.attributeName, '>=', min)
    }

    if (max !== undefined) {
      this.searchStore.addNumericRefinement(this.attributeName, '<=', max)
    }

    this.searchStore.start()
    this.searchStore.refresh()
  },

  destroyed () {
    this.searchStore.stop()
    this.searchStore.removeFacet(this.attributeName)
    this.searchStore.start()
  },

  computed: {
    refinement () {
      const { numericValue: min } =
        this.searchStore.activeRefinements.find(
          ({ attributeName, type, operator }) =>
            attributeName === this.attributeName &&
            type === 'numeric' &&
            operator === '>='
        ) || {}

      const { numericValue: max } =
        this.searchStore.activeRefinements.find(
          ({ attributeName, type, operator }) =>
            attributeName === this.attributeName &&
            type === 'numeric' &&
            operator === '<='
        ) || {}

      return {
        min,
        max
      }
    },
    refinementForRendering () {
      const { min: minValue, max: maxValue } = this.refinement
      return {
        // apparently only this date format works.
        min: (minValue !== undefined && minValue !== '') ? format(fromUnixTime(minValue), 'yyyy-MM-dd') : '',
        max: (maxValue !== undefined && maxValue !== '') ? format(fromUnixTime(maxValue), 'yyyy-MM-dd') : ''
      }
    }
  },
  methods: {
    onInputMin (value) {
      this.refinement.min = value ? parse(value, 'yyyy-MM-dd', new Date()).getTime() / 1000 : ''
      this.onSubmit(this.refinement)
    },
    onInputMax (value) {
      this.refinement.max = value ? parse(value, 'yyyy-MM-dd', new Date()).getTime() / 1000 : ''
      this.onSubmit(this.refinement)
    },
    onSubmit ({ min: minNext = '', max: maxNext = '' }) {
      const { min: minRange, max: maxRange } = this.range

      const hasMinBound = this.min !== undefined
      const hasMaxBound = this.max !== undefined

      const isMinReset = minNext === ''
      const isMaxReset = maxNext === ''

      const minNextAsString = !isMinReset ? parseFloat(minNext) : undefined
      const maxNextAsString = !isMaxReset ? parseFloat(maxNext) : undefined

      const newMinNext = this.nextValueForRefinment(
        hasMinBound,
        isMinReset,
        minRange,
        minNextAsString
      )

      const newMaxNext = this.nextValueForRefinment(
        hasMaxBound,
        isMaxReset,
        maxRange,
        maxNextAsString
      )

      this.searchStore.stop()

      this.searchStore.removeNumericRefinement(this.attributeName, '>=')
      if (newMinNext !== undefined) {
        this.searchStore.addNumericRefinement(
          this.attributeName,
          '>=',
          newMinNext
        )
      }

      this.searchStore.removeNumericRefinement(this.attributeName, '<=')
      if (newMaxNext !== undefined) {
        this.searchStore.addNumericRefinement(
          this.attributeName,
          '<=',
          newMaxNext
        )
      }

      this.searchStore.start()
      this.searchStore.refresh()
    }
  }
}
</script>

<style lang='scss'>

.ais-dates-range-input {
  .v-input__control, .v-input__slot {
    width: 90px;
  }
}

.ais-dates-range-input__separator {
  color: rgba(0, 0, 0, 0.63);
  font-size: 16px;
}
</style>
